import { api } from '@cems-eco/core/src/services/api';
import { ReportFilter, ReportFormat } from './index';

export abstract class BaseReportApi {
    BASE_URL: string;


    constructor() {
        this.BASE_URL = "/report";
    }

    async allByEquipment(equipmentId: any): Promise<any> {
        const url = this.BASE_URL + '/equipment/' + equipmentId + '/30m';
        return await api.get<any>(url);
    }

    async header(reportFilter: ReportFilter): Promise<any> {
        const url = this.BASE_URL + '/header';
        return await api.post<any>(url, reportFilter);
    }

    async allByReportFilter(reportFilter: ReportFilter, format: ReportFormat, additionalParam: any = {}): Promise<any> {
        const params = {
            search: {
                advanced: {
                    ...reportFilter
                }
            }
        }
        let uri = api.toSerialize(params);
        if (Object.keys(additionalParam).length) {
            uri = uri + `&${api.toSerialize(additionalParam)}`;
            const url = this.BASE_URL + '/' + format.toString() + '?' + encodeURI(uri);

            return await api.get<any>(url);
        } else {
            const url = this.BASE_URL + '/' + format.toString() + '?' + encodeURI(uri);
            return await api.get<any>(url);
        }
    }

    async all(): Promise<any> {
        return await api.get<any>(this.BASE_URL);
    }

    async first(id: any): Promise<any> {
        return await api.get<any>(`${this.BASE_URL}/${id}`);
    }

    async create(data: any): Promise<any> {
        return await api.post<any>(this.BASE_URL, data);
    }

    async edit(id: any, data: any): Promise<any> {
        return await api.put<any>(`${this.BASE_URL}/${id}`, data);
    }

    async destroy(id: any): Promise<any> {
        return await api.delete<any>(`${this.BASE_URL}/${id}`);
    }

    async download(params: any, format: ReportFormat, fileName: string): Promise<any> {
        const uri = api.toSerialize(params);
        const url = this.BASE_URL + '/' + format.toString() + '?' + encodeURI(uri);
        return await api.downloadFile<any>(url, fileName);
    }

    async sensorByEquipment(equipment_id: any): Promise<any> {
        const params = {
            "no-paginate": true,
            search: {
                advanced: {
                    equipment_id
                }
            }
        }
        return await api.get<any>(`/sensor`, params);
    }

    getUrl(url, params = {}): string {
        return api.getUrl(url, params);
    }

    async getOptions(url, params = {}, keyValue = 'id'): Promise<any[]> {
        let response = await api.get<any>(url, params);
        return (response.data as any[]).map((e) => ({
            label: e.text,
            value: e[keyValue],
        }));
    }

}
